import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    country: '',
    interest: '',
    message: ''
  });
  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Format the WhatsApp message
    const whatsappMessage = `Hello Cleophas Network!%0A%0A*New Contact Form Submission*%0A%0A*Name:* ${encodeURIComponent(formData.name)}%0A*Phone:* ${encodeURIComponent(formData.phone)}%0A*Email:* ${encodeURIComponent(formData.email || 'Not provided')}%0A*Country:* ${encodeURIComponent(formData.country)}%0A*Interest:* ${encodeURIComponent(formData.interest)}%0A%0A*Message:*%0A${encodeURIComponent(formData.message)}`;
    
    // Create WhatsApp URL
    const whatsappURL = `https://wa.me/254115647545?text=${whatsappMessage}`;
    
    // Show success message
    setShowSuccess(true);
    
    // Open WhatsApp after a short delay
    setTimeout(() => {
      window.open(whatsappURL, '_blank');
      
      // Reset form after submission
      setFormData({
        name: '',
        phone: '',
        email: '',
        country: '',
        interest: '',
        message: ''
      });
      
      // Hide success message after 5 seconds
      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
    }, 1500);
  };

  return (
    <div>
      {/* Contact Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Contact Us</h1>
          <p className="text-xl max-w-2xl mx-auto">Get in touch with us for any questions about VumaQash or Cleophas Network</p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-content">
        <div className="container">
          <div className="contact-grid mb-16">
            <div className="contact-card">
              <div className="contact-icon">
                <i className="fab fa-whatsapp"></i>
              </div>
              <h3 className="text-xl font-semibold mb-4">WhatsApp</h3>
              <p className="mb-4">Get quick responses via WhatsApp for any questions about VumaQash</p>
              <a href="https://wa.me/254115647545?text=Hey%20Cleophas,%20I'm%20interested%20in%20VumaQash%20Agencies" className="cta-button">
                <i className="fab fa-whatsapp mr-2"></i> Message Us
              </a>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <h3 className="text-xl font-semibold mb-4">Email</h3>
              <p className="mb-4">Send us an email and we'll get back to you within 24 hours</p>
              <a href="mailto:CLEOPHASKE254@GMAIL.COM" className="cta-button">
                <i className="fas fa-envelope mr-2"></i> Email Us
              </a>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">
                <i className="fas fa-users"></i>
              </div>
              <h3 className="text-xl font-semibold mb-4">Community</h3>
              <p className="mb-4">Join our WhatsApp community to connect with other members</p>
              <a href="https://chat.whatsapp.com/KbT7KexfwR48EYYEAeNyrH" className="cta-button">
                <i className="fas fa-users mr-2"></i> Join Group
              </a>
            </div>
          </div>
          
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold mb-6 text-center">Send Us a Message via WhatsApp</h2>
            
            <div className="whatsapp-prompt">
              <i className="fab fa-whatsapp"></i>
              <p>Your message will be sent directly to our WhatsApp for immediate response</p>
            </div>
            
            <div className="contact-form">
              <form id="contactForm" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Your Full Name *</label>
                  <input 
                    type="text" 
                    id="name" 
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required 
                    placeholder="Enter your full name" 
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="phone">WhatsApp Number *</label>
                  <input 
                    type="tel" 
                    id="phone" 
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required 
                    placeholder="Include country code (e.g., +254...)" 
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input 
                    type="email" 
                    id="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Your email address (optional)" 
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="country">Your Country *</label>
                  <select 
                    id="country" 
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select your country</option>
                    <option value="Kenya">Kenya</option>
                    <option value="Uganda">Uganda</option>
                    <option value="Tanzania">Tanzania</option>
                    <option value="Nigeria">Nigeria</option>
                    <option value="Ghana">Ghana</option>
                    <option value="South Africa">South Africa</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label htmlFor="interest">I'm interested in *</label>
                  <select 
                    id="interest" 
                    name="interest"
                    value={formData.interest}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select an option</option>
                    <option value="VumaQash Registration">VumaQash Registration</option>
                    <option value="Earning Methods">Learning about earning methods</option>
                    <option value="Affiliate Program">Affiliate Program</option>
                    <option value="Support">Technical Support</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Your Message *</label>
                  <textarea 
                    id="message" 
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required 
                    placeholder="Tell us how we can help you..." 
                  ></textarea>
                </div>
                
                <button type="submit" className="cta-button w-full">
                  <i className="fab fa-whatsapp mr-2"></i> Send via WhatsApp
                </button>
              </form>
              
              <div id="whatsappSuccess" className={`whatsapp-success ${showSuccess ? 'show' : ''}`}>
                <i className="fas fa-check-circle mr-2"></i>
                <span>Your message is ready to be sent! Opening WhatsApp...</span>
              </div>
              
              <div className="form-note">
                <p>* Required fields. We respect your privacy and will never share your information with third parties.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-gray-50">
        <div className="container">
          <h2 className="text-3xl font-bold text-center mb-12">Frequently Asked Questions</h2>
          
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-3 flex items-center">
                <i className="fas fa-question-circle text-blue-500 mr-2"></i>
                How quickly can I start earning?
              </h3>
              <p className="text-gray-600">Many members see their first earnings within the first week of joining. The speed depends on how actively you engage with the platform.</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-3 flex items-center">
                <i className="fas fa-question-circle text-blue-500 mr-2"></i>
                Do I need any special skills?
              </h3>
              <p className="text-gray-600">No special skills are required. We provide comprehensive training and support to help you succeed, even as a complete beginner.</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-3 flex items-center">
                <i className="fas fa-question-circle text-blue-500 mr-2"></i>
                Is there ongoing support?
              </h3>
              <p className="text-gray-600">Yes! We offer 24/7 customer support through WhatsApp and our community group to help you with any questions or issues.</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-3 flex items-center">
                <i className="fas fa-question-circle text-blue-500 mr-2"></i>
                How do I withdraw my earnings?
              </h3>
              <p className="text-gray-600">Earnings can be withdrawn directly to your mobile money account or bank account, depending on your country. The process is quick and seamless.</p>
            </div>
          </div>
          
          <div className="text-center mt-12">
            <p className="text-lg mb-6">Have more questions? We're here to help!</p>
            <a href="https://wa.me/254115647545?text=I%20have%20questions%20about%20VumaQash" 
               className="inline-flex items-center bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-lg transition-colors">
              <i className="fab fa-whatsapp mr-2 text-xl"></i> Chat with Us on WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;